import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';

import { fogotPassword } from "../../api/authentication";
import {  EmailValidation } from '../../util/input-validation.js';
import { useToast } from 'components/common/custom-toast/Toast';

const ForgetPasswordForm = ({sucessMessageHandle}) => {
  const [email, setEmail] = useState('');
  const [errorText, setErrorText] = useState('');
  const [showErrorText, setShowErrorText] = useState(false);
  const [requestError, setRequestError] = useState();
  const toast = useToast()

  useEffect(() => {
    let emailStatus = EmailValidation(email);

    setErrorText(emailStatus ? '' : 'Email a valid Email address');
    setShowErrorText(false);
    setRequestError('');
  }, [email]);

  // Handler
  const handleSubmit = e => {
    e.preventDefault();
    if (email) {
      toast.success(`An email is sent to ${email} with password reset link`);
    }
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    if (!errorText) {
        const data = await fogotPassword(email);

        if (data?.code === 200) {
            sucessMessageHandle(true, email);
        } else if (data?.error) {
            setRequestError(data?.error);
        } else {
            setRequestError('Something unexpected happenned');
        }
    } else {
        setShowErrorText(true);
    }
};

  return (
    <Form className="mt-4" onSubmit={handleFormSubmit}>
      <Form.Group className="mb-3">
        <Form.Control
          placeholder={'Email address'}
          value={email}
          name="email"
          onChange={({ target }) => setEmail(target.value)}
          type="email"
          style={{fontSize: "1rem"}}
        />
        {showErrorText && (
          <p
            className="text-danger"
            style={{ fontSize: "12px", paddingTop: "4px" }}
          >
            {errorText.email}
          </p>
        )}
      </Form.Group>

      <Form.Group className="mb-3">
        {requestError && (
          <p style={{ color: 'red', fontSize: "12px" }}>
              * {requestError}{' '}
          </p>
        )}
        <Button className="w-100" type="submit" disabled={!email}>
          Send reset link
        </Button>
      </Form.Group>
    </Form>
  );
};

export default ForgetPasswordForm;
